import { newsArticles, type NewsArticle } from "./news";

export type NewsStatus = "draft" | "review" | "published" | "archived";

export interface AdminArticle extends NewsArticle {
  status: NewsStatus;
  location: string;
  seoTitle: string;
  metaDescription: string;
}

export const newsCategories = [
  "Breaking News",
  "Local News",
  "National News",
  "International News",
  "Politics",
  "Business",
  "Technology",
  "Society",
  "Religion",
  "Culture",
  "Sports",
  "Entertainment",
  "Lifestyle",
];

export const newsStatusOptions: { value: NewsStatus; label: string }[] = [
  { value: "draft", label: "Draft" },
  { value: "review", label: "Pending Review" },
  { value: "published", label: "Published" },
  { value: "archived", label: "Archived" },
];

// Map public articles into admin records with an editorial status, so the
// Newsroom CMS demonstrates the full Draft → Review → Published workflow.
const statusSequence: NewsStatus[] = ["published", "review", "draft", "published", "published", "review"];

export const adminArticles: AdminArticle[] = newsArticles.map((a, i) => ({
  ...a,
  status: statusSequence[i % statusSequence.length],
  location: "Edea, Cameroon",
  seoTitle: a.headline,
  metaDescription: a.excerpt,
}));